import React from 'react';
import { Modal } from 'react-bootstrap';
import './index.scss';

const DemoVideoModal = ({ show, onHide, videoUrl = "https://www.youtube.com/embed/nmyQ2L3Zcms?si=BkZ0IfjeY9rj1mMq&autoplay=1" }) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    size="xl"
    className="demo-video-modal"
  >
    <Modal.Header closeButton />
    <Modal.Body className="p-0">
      <div className="demo-video-container">
        <iframe
          width="100%"
          height="100%"
          src={videoUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </Modal.Body>
  </Modal>
);

export default DemoVideoModal; 